"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Page = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _Core = require("../../components/Core");

var _styled = require("../../styles/styled");

var Page =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Page, _Component);

  function Page(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = Page.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        fullWidth = _this$props.fullWidth,
        header = _this$props.header,
        footer = _this$props.footer,
        children = _this$props.children;
    return _react.default.createElement(PageWrapper, {
      fullWidth: fullWidth,
      py: 2
    }, header && header, _react.default.createElement("div", null, children, footer && footer));
  };

  return Page;
}(_react.Component);

exports.Page = Page;
var PageWrapper = (0, _styled.styled)(_Core.Box).withConfig({
  componentId: "zy84c3-0"
})(["", ";"], function (props) {
  return !props.fullWidth && (0, _styled.css)(["max-width:1100px;margin:0 auto;width:100%;"]);
});